import React, {useContext} from "react";
import {RowDivF1} from "../../styledComponents/CustomStyledComponents";
import {SkeletonLineF, StyledSkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {useTranslation} from "react-i18next";

import '../CountryGraphicsStyles.css';
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";

import { formatNumber } from "../../../services/helpers";

const PillTier: React.FC<{tier: string}> = ({tier = ''}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    return(
        allDataLoaded ?
            <div className='pillTierContainerWrapper'>
                <div className='pillTier'>
                    <span>Tier:</span>
                    <span className='tier'>{` ${tier}/3`}</span>
                </div>
            </div>
            :
            <div style={{ width: '90%'}}>
                <SkeletonLineF />
            </div>
    )
};


interface InfoBoxInterface {
    showLinkButton?: boolean,
    customStyle?: object,
    countryInfo?: any,
}

const GraphicsInfoBox: React.FC<InfoBoxInterface> = ({customStyle = {}, countryInfo}) => {
    const { t, i18n } = useTranslation();

    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);
    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';
    const lng = getCurrentLng() === 'es' ? 'de' : getCurrentLng();

    const info = [
        {label: t('countryContainer.infoBox.group'), value: t(`groups.${countryInfo?.group}`)},
        {label: t('countryContainer.infoBox.subGroup'), value: t(`regions.${countryInfo?.subgroup}`)},
        {label: t('countryContainer.infoBox.gip'), value: formatNumber(parseFloat(countryInfo?.gip), 2, lng)},
        {label: t('countryContainer.infoBox.ranking'), value: countryInfo?.gip_ranking},
        {label: t('countryContainer.infoBox.gai'), value: formatNumber(parseFloat(countryInfo?.gai), 2, lng)},
        {label: t('countryContainer.infoBox.rankingGai'), value: countryInfo?.gai_ranking}
    ];

    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;

    return (
        <div style={{border: `3px solid ${color}`, display: "flex", flexDirection: "column",  padding: '0 50 50 50', ...customStyle}}>
            <RowDivF1 style={{color: color, marginTop: 10}}>
                <div>{t('countryContainer.infoBox.title')}</div>
            </RowDivF1>
            <div style={{flex: '1 1 auto'}}>
                <PillTier tier={countryInfo?.tier}/>
            </div>
            { info && info.map((element: any, index: any) => (
                <div style={{flex: '1 1 auto'}}>
                    <RowDivF1 key={index} style={{marginTop: 10, fontSize: 24}}>
                        <div style={{color: color, flex: 1}}>{element.label}:</div>
                        <div style={{color: color, fontFamily: 'Mapfre-Light', flex: 1}}>
                            { allDataLoaded ? element.value : <StyledSkeletonLine customStyle={{ width: '80%'}}/> }
                        </div>
                    </RowDivF1>
                </div>
            ))}
        </div>
    )
};

export default GraphicsInfoBox;
